import React, { Component } from 'react';
import { bool, number, string, shape, arrayOf, object } from 'prop-types';
import classnames from 'classnames';
import LazyLoad from 'components/LazyLoad';
import Figure from 'components/Figure';
import Html from 'components/Html';
import SideBySide from 'components/SideBySide';
import Video from 'components/Video';

import styles, { globalStyles } from './styles';

function getId(pos) {
  return pos ? `faq-${pos}` : undefined;
}

// CLEANUP: Quick workaround to detect custom html Giphy embeds. These will hopefully
// be converted to a type (or image) in the future, however the Instant Pot FAQ
// includes LOT of Giphy embeds that are HUGE. This function is used to naively
// detect Giphy embeds so the HTML block can be lazy loaded.
function isGiphy(html) {
  return html.includes('giphy.com/embed');
}

class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = { isAnswerVisible: false };
  }

  componentDidMount() {
    const { pos } = this.props;
    if (window.location.hash === `#${getId(pos)}`) {
      this.setState({ isAnswerVisible: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }

  toggleAnswer = e => {
    e.preventDefault();
    const isAnswerVisible = !this.state.isAnswerVisible;
    this.setState({ isAnswerVisible }, () => {
      // Run force check to ensure any lazy loaded content is checked when the
      // answer becomes visible
      if (isAnswerVisible) {
        LazyLoad.runForceCheck();
      }
    });
  };

  render() {
    const {
      pos,
      title,
      items,
      post,
      isPartner,
      isAffiliate,
      hasPrism
    } = this.props;
    const { isAnswerVisible } = this.state;
    const id = getId(pos);
    return (
      <div className={classnames('Faq', { 'Faq--expanded': isAnswerVisible })}>
        <h3>
          <a
            id={id}
            href={id ? `#${id}` : undefined}
            onClick={this.toggleAnswer}
          >
            {pos && <span className="Faq__pos">{pos}</span>}
            {title}
          </a>
        </h3>
        {isPartner && <span className="Faq__partnerLabel">Partner</span>}
        <div
          className="Faq__items"
          style={isAnswerVisible ? {} : { display: 'none' }}
        >
          {items.map(item => {
            const props = {
              ...item.data,
              post,
              isAffiliate,
              hasPrism
            };
            let element = null;
            switch (item.type) {
              case 'html':
                element = isGiphy(item.data.html) ? (
                  <LazyLoad
                    placeholder={<div style={{ padding: '0 0 42% 0' }} />}
                    once
                  >
                    <Html {...props} />
                  </LazyLoad>
                ) : (
                  <Html {...props} />
                );
                break;
              case 'image':
                element = <Figure {...props} placement="faqItem" />;
                break;
              case 'sideBySide':
                element = <SideBySide {...props} variant="small" />;
                break;
              case 'video':
                // Override video placement
                element = <Video {...props} />;
                break;
              default:
                element = null;
            }
            return (
              <div key={item.id} className="Faq__item">
                {element}
              </div>
            );
          })}
        </div>

        <style jsx global>
          {globalStyles}
        </style>
        <style jsx>{styles}</style>
      </div>
    );
  }
}

Faq.defaultProps = {
  pos: undefined,
  post: undefined,
  isPartner: false,
  isAffiliate: false,
  hasPrism: false
};

Faq.propTypes = {
  title: string.isRequired,
  items: arrayOf(
    shape({
      type: string,
      data: object
    })
  ).isRequired,
  post: shape({
    canonical: string
  }),
  pos: number,
  isPartner: bool,
  isAffiliate: bool,
  hasPrism: bool
};

export default Faq;
